import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HomeGallerySection from '../../../organisms/HomeEditorial/HomeGallerySection';

/**
 * Gallery section. Always renders the section frame; the bento grid
 * appears once real photos exist for the band, otherwise an editorial empty
 * state is shown — no fabricated images.
 */
export default function BandGallerySection({
  id = 'gallery',
  eyebrow,
  title,
  side,
  photos = [],
  isEditing = false,
  onPhotoClick,
  onUploadPhoto,
  onDeletePhoto,
  onReorderPhotos,
  deletingPhotoId = null,
  isReorderingPhotos = false,
  uploadPhotoLabel,
  deletePhotoLabel,
  previousPhotosLabel,
  nextPhotosLabel,
  emptyTitle,
  emptyDescription,
}) {
  const { t } = useTranslation();
  return (
    <HomeGallerySection
      id={id}
      eyebrow={eyebrow || t('bandPage.gallery.eyebrow', { defaultValue: 'Gallery' })}
      title={title || t('bandPage.gallery.title', { defaultValue: 'Photos from the band.' })}
      side={side}
      photos={photos}
      photosLabel={t('bandPage.gallery.photos', { defaultValue: 'Photos' })}
      className="band-gallery"
      isEditing={isEditing}
      onPhotoClick={onPhotoClick}
      onUploadPhoto={onUploadPhoto}
      onDeletePhoto={onDeletePhoto}
      onReorderPhotos={onReorderPhotos}
      deletingPhotoId={deletingPhotoId}
      isReorderingPhotos={isReorderingPhotos}
      uploadPhotoLabel={uploadPhotoLabel || t('bandPage.gallery.uploadPhoto', { defaultValue: 'Upload photo' })}
      deletePhotoLabel={deletePhotoLabel || t('bandPage.gallery.deletePhoto', { defaultValue: 'Delete photo' })}
      previousPhotosLabel={previousPhotosLabel || t('bandPage.gallery.previousPhotos', { defaultValue: 'Scroll photos left' })}
      nextPhotosLabel={nextPhotosLabel || t('bandPage.gallery.nextPhotos', { defaultValue: 'Scroll photos right' })}
      emptyPhotosTitle={emptyTitle || t('bandPage.gallery.emptyTitle', { defaultValue: 'No photos yet' })}
      emptyPhotosDescription={emptyDescription || t('bandPage.gallery.emptyDescription', { defaultValue: 'Photos posted by the band will appear here.' })}
    />
  );
}

BandGallerySection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  side: PropTypes.node,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageUrl: PropTypes.string,
    url: PropTypes.string,
    thumb: PropTypes.string,
    caption: PropTypes.node,
    size: PropTypes.oneOf(['default', 'lg', 'md', 'tall']),
    alt: PropTypes.string,
  })),
  isEditing: PropTypes.bool,
  onPhotoClick: PropTypes.func,
  onUploadPhoto: PropTypes.func,
  onDeletePhoto: PropTypes.func,
  onReorderPhotos: PropTypes.func,
  deletingPhotoId: PropTypes.string,
  isReorderingPhotos: PropTypes.bool,
  uploadPhotoLabel: PropTypes.node,
  deletePhotoLabel: PropTypes.string,
  previousPhotosLabel: PropTypes.string,
  nextPhotosLabel: PropTypes.string,
  emptyTitle: PropTypes.node,
  emptyDescription: PropTypes.node,
};
